import { connect } from 'react-redux'
import { getPupilFetchingStatus } from '../../../../stores/profile/profile.selectors'
import Profile from './profile'
import { withRouter } from 'react-router'
import { fetchProfile } from '../../../../stores/profile/profile.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match }) => {
  const { pending, requestError } =
    getPupilFetchingStatus(state, match.params.id) || {}
  return {
    showLoadingScreen: pending,
    showProfile: !pending && !requestError
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  onMount: () => dispatch(fetchProfile(match.params.id)).catch(errorHandler)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
)
